import React, { Component } from 'react';
import cookie from '../../src/cookiecut.png';
import { Button } from '@blueprintjs/core';
import{withRouter,Link} from 'react-router-dom';
import { observer , inject } from 'mobx-react';



@withRouter
@inject("store")
@observer

export default class EventModel extends Component
{
    back(){
        this.props.store.storymodel = "nothing";
       
        this.forceUpdate();
        this.props.history.push("/storymodel")
    }

    event(){
        this.props.store.eventmodel = "nothing";
        this.forceUpdate();
    }

    treasure(){
        this.props.store.eventmodel = "treasure";
        this.forceUpdate();
    }

    detective(){
        this.props.store.eventmodel = "detective";
        this.forceUpdate();
    }

    will(){
        this.props.store.eventmodel = "will";
        this.forceUpdate();
    }

    badthing(){
        this.props.store.eventmodel = "badthing";
        this.forceUpdate();
    }

    live(){
        this.props.store.eventmodel = "live";
        this.forceUpdate();
    }

    
    render()
    {
        return <>
        
        {this.props.store.eventmodel == "nothing" &&  <div className = "modeltext">
        欢迎来到事件模版~<br/><br/>
        从小故事指南中，已经讲过事件意味着变化<br/>
        好的变化不仅发生在人物身上，而且由冲突造成<br/><br/>

        但这样讲还是不够清楚，为了让大家更容易理解<br/>
        这里提供五个事件模版<br/>
        
        
        
       <br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.treasure() } >寻宝故事</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.detective() } >探秘故事</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.will() } >如愿以偿</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.badthing() } >天降横祸</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.live() } >生活的妥协</Button><br/>

<div className = "buttonbox">
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.back() } >返回模版</Button><br/>
    </div>   
    </div> }

    {this.props.store.eventmodel == "treasure" &&  <div className = "modeltext">
        寻宝故事，指主角及其团队寻找宝藏的故事。<br/>
        大部分的探险，盗墓，寻宝都属于此类<br/>
        绿野仙踪，回到未来，甚至四大名著中的西游记，也都属于这个事件模版<br/><br/>
        一个典型的寻宝故事中，首先需要一个宝藏<br/>
        其次，需要明确的寻宝旅程<br/>
        最后需要路途中的成长，包括发现自我，和同伴的友情等等<br/><br/>
        这是非常常见的事件模版，在许多神话传说中都有出现<br/>
        如果对这个模版感兴趣，可以试着写写看哦~<br/><br/>
           <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.event() } >返回人物模版</Button><br/>

        
        </div>}


        {this.props.store.eventmodel == "detective" &&  <div className = "modeltext">
            探秘故事，是指主角发现一个秘密后，寻找谜底的故事<br/>
            大部分的侦探，破案，解密都属于这种故事模版<br/><br/>
            一个典型的探秘故事中，首先，需要一个秘密<br/>
            其次，需要发现秘密并关心秘密的探秘者<br/>
            最后，需要探秘的艰难过程，很可能伴随着探秘者的自我牺牲<br/><br/>
            这是扣人心弦，而且最容易设置悬疑的事件模版<br/>
            感兴趣的话可以写写看哦~<br/><br/>
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.event() } >返回人物模版</Button><br/>

            </div>}

            {this.props.store.eventmodel == "will" &&  <div className = "modeltext">
                如愿以偿是指，主角的愿望忽然实现，随后发生的故事<br/>
                电影百万英镑和西虹市首富都用了相同的愿望：一夜暴富<br/>
                夏洛特烦恼中的愿望是重返过去<br/>
                人生遥控器则是另一个愿望：能控制时间<br/><br/>
                典型的如愿以偿故事，首先需要一个大部分人都会有的愿望<br/>
                其次，需要规则和限制。<br/>
                比如得到钱但需要一天花完，能跳过讨厌的时光，但每次都会自动跳过<br/>
                最后，会得到一个教训。（通常是愿望是虚幻的，还是原来好）<br/>
                <br/>
                这个事件模版，一般是欢乐的喜剧或闹剧。<br/>
                以大家都感兴趣的白日梦作为引子<br/>
                吸引大家进来后，结尾升华得到启示和教训<br/>
                是一个比较完整，也简单易写的事件类型<br/>
                大家有兴趣可以试着写写哦~<br/><br/>
                <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.event() } >返回人物模版</Button><br/>

                </div>}


                {this.props.store.eventmodel == "badthing" &&  <div className = "modeltext">
                    天降横祸，是指主角的生活中，忽然出现巨大的灾祸，随后发生的故事。<br/>
                    比如灾难片 《2012》，反映当时社会环境的《辛德勒名单》，或者周星驰有名的喜剧《功夫》<br/>
                    <br/>
                    一个典型的天降横祸故事中，首先需要一个普通，甚至平凡，无辜的主角。<br/>
                    紧接着，是突然降临大灾祸，很可能关乎生死<br/>
                    最后，主角要能战胜，或者部分战胜这个灾祸<br/>
                    毕竟如果开头就躺倒，那也没有什么故事了对吧<br/><br/>
                    这是一种非常有代入感的事件模版,<br/>
                    因为大部分观众也都是平凡人，每天都在努力应对各种各样的麻烦<br/>
                    如果对这个模版感兴趣，可以试着写写看哦<br/><br/>
                    <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.event() } >返回人物模版</Button><br/>
                    </div>}

                    {this.props.store.eventmodel == "live" &&  <div className = "modeltext">
                        生活的妥协，是非常具有现实意义的事件模版<br/>
                        一个典型的生活的妥协，首先有个常见问题<br/>
                        这个问题不是偶然的，而是常见的。可能发生在我们每个人的身上。<br/>
                        这个问题不是具体由某个坏人带来的，而是模糊的，无形的，甚至无处不在的<br/>
                        这个问题不是突然发生的，而是一直存在于我们生活中的<br/>
                        这个类型中，常见的分支有：青春期难题，中年危机，离婚或分手，面对死亡，面对重病，酒精或毒品上瘾等等<br/>
                        紧接着问题，紧接着是一个错误的应对方式<br/>
                        主角的第一反应，一般是否认，逃避，或者过激反应<br/>
                        但在最后，TA找到了正确的面对方式，通常是与生活妥协。直面问题，心中释然<br/>
                        <br/>
                        也就是：常规问题，错误反应和释然妥协<br/><br/>
                        这种事件模版是生活的隐喻，会带领观众与读者一起应对生活中的问题<br/>
                        指出更正确的解决之道，让大家在真正的痛苦和艰难中，能够获得力量<br/><br/>
                        这是一种非常难写，需要生活感悟的事件模版<br/>
                        当然大家有兴趣还是可以写写看<br/><br/>
                        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.event() } >返回人物模版</Button><br/>
                        </div>}
        
   
        </>;
    }
} 